export default __webpack_public_path__ + "static/temp-image-c372267cdef4eb73d6abd1bcfcfffe92.png";